import { Form } from '@/features/pos/components/ProductConfigurationModal/form/types'
import { OnConfirm } from '@/features/pos/components/ProductConfigurationModal/types'
import { useCallback, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

export const useConfirmForm = (
    onConfirm: OnConfirm
): [{ isValid: boolean; isSubmitting: boolean }, () => void] => {
    const { formState, handleSubmit } = useFormContext<Form>()
    const inFlight = useRef(false)

    return [
        { isValid: formState.isValid, isSubmitting: formState.isSubmitting },
        useCallback(async () => {
            if (inFlight.current) return

            inFlight.current = true

            try {
                await handleSubmit(onConfirm)()
            } finally {
                inFlight.current = false
            }
        }, [handleSubmit, onConfirm]),
    ]
}
